export enum KnmHeaderActionsEnum {
  KNM_COMPLETE336 = 'KNM_COMPLETE336',
  KNM_HEADER_HANDLE_TO_APPROVE_CLICK = 'KNM_HEADER_HANDLE_TO_APPROVE_CLICK',
}
